<template>
  <div>
    <div class="opc-summary-text opc-summary-title">
      {{
        $t('billing.order_summary.new_monthly_total_starting', {
          date: getProAnnualBilledMonthlyExpireFormatDate
        })
      }}
      <div class="opc-summary-amount">
        <vloader :loading='loading' :value='$money(mx_price(getSelectedPlans && getSelectedPlans[0]))' />
      </div>
    </div>

    <div class="opc-summary-text light-text">{{ $t('billing.order_summary.extra_charges') }}</div>
  </div>
</template>

<script>
import proAnnualBilledMonthlyMixin from '@/plans/ZOOM_MEETING/mixin/pro-annual-billed-monthly';
import shoppingCartMixin from '@/plans/mx/shopping-cart.vue';
import vloader from '@/views/config/shopping-cart/prorated/vloader.vue';

export default {
  name: 'PendingPlanSummary',
  components: { vloader },
  mixins: [proAnnualBilledMonthlyMixin, shoppingCartMixin],
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.opc-summary-title {
  display: flex;
  justify-content: space-between;
}
.opc-summary-text {
  color: #00031F;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 16.8px */
  &.light-text {
    color:  #666487;
    font-weight: 400;
  }
}
</style>
